import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=5c5433a0&"
import script from "./Developers.vue?vue&type=script&lang=ts&"
export * from "./Developers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports